import React, { useEffect, useState } from 'react';
import LayoutDefault from 'Components/LayoutDefault/LayoutDefault';
import CostSpreadsheet from './CostSpreadsheet/CostSpreadsheet';
import CostPerDay from './CostPerDay/CostPerDay';
import NewMonthPanel from './NewMonthPanel/NewMonthPanel';
import DeleteMonthPanel from './DeleteMonthPanel/DeleteMonthPanel';
import Panel from 'Components/Panel/Panel';

const HourlyCostSpreadsheet = (
    {
    }) => {
    useEffect(() => {
        document.title = "Redech | Orçamento anual"
    }, [])

    const [itemsMonth, setItemsMonth] = useState(null);
    const [itemInValidation, setItemInValidation] = useState(false);
    const [showDetailItem, setShowDetailItem] = useState(null);
    const [comboBoxYear, setComboBoxYear] = useState(new Date());
    const [updatePanelCostSpreadsheet, setUpdatePanelCostSpreadsheet] = useState(false);

    const [showNewMonthPanel, setShowNewMonthPanel] = useState(false);
    const [showDeleteMonthPanel, setShowDeleteMonthPanel] = useState(false);
    const [rowIndexSelected, setRowIndexSelected] = useState(null);
    const [closeCostSpreadsheet, setCloseCostSpreadsheet] = useState(false)
    const [loadingItemsMonth, setLoadingItemsMonth] = useState(false);


    useEffect(() => {
        setCloseCostSpreadsheet(false)
        setItemInValidation(null)
    }, [comboBoxYear])

    const handleClose = () => {
        setCloseCostSpreadsheet(false)
        setRowIndexSelected(null)
    };

    function onUpdateItemInValidation(key) {
        if (key && ([1, 2, 3].includes(key.key) || !key.currentMonth)) {
            return
        } else {
            setCloseCostSpreadsheet(true)
            setItemInValidation(key)
            if (key.index != null) {
                setRowIndexSelected(key.index)
            }
        }
    }

    function onUpdateRowIndexSelected(key) {
        if (key && ([1, 2, 3].includes(key.key) || !key.currentMonth)) {
            return
        } else {
            if (key.index != null) {
                setRowIndexSelected(key.index)
            }
        }
    }

    return (
        <>
            <LayoutDefault>
                <NewMonthPanel
                    showNewMonthPanel={showNewMonthPanel}
                    onUpdateShowNewMonthPanel={setShowNewMonthPanel}
                    onUpdatePanelCostSpreadsheet={setUpdatePanelCostSpreadsheet}
                    onUpdateLoadingItemsMonth={setLoadingItemsMonth}
                />
                <Panel style={{ backgroudColor: '#f5f5f5', width: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'row' }}>
                    <DeleteMonthPanel
                        showDeleteMonthPanel={showDeleteMonthPanel}
                        onUpdateShowDeleteMonthPanel={setShowDeleteMonthPanel}
                        onUpdatePanelCostSpreadsheet={setUpdatePanelCostSpreadsheet}
                        onUpdateLoadingItemsMonth={setLoadingItemsMonth}
                    />
                    <CostSpreadsheet
                        itemInValidation={itemInValidation}
                        itemsMonth={itemsMonth}
                        comboBoxYear={comboBoxYear}
                        showNewMonthPanel={showNewMonthPanel}
                        showDeleteMonthPanel={showDeleteMonthPanel}
                        updatePanelCostSpreadsheet={updatePanelCostSpreadsheet}
                        rowIndexSelected={rowIndexSelected}
                        closeCostSpreadsheet={closeCostSpreadsheet}
                        loadingItemsMonth={loadingItemsMonth}
                        onUpdateItemInValidation={onUpdateItemInValidation}
                        onUpdateShowDetailItem={setShowDetailItem}
                        onUpdateItemsMonth={setItemsMonth}
                        onUpdateComboBoxYear={setComboBoxYear}
                        onUpdateShowNewMonthPanel={setShowNewMonthPanel}
                        onUpdateShowDeleteMonthPanel={setShowDeleteMonthPanel}
                        onUpdatePanelCostSpreadsheet={setUpdatePanelCostSpreadsheet}
                        onUpdateRowIndexSelected={onUpdateRowIndexSelected}
                        onUpdateLoadingItemsMonth={setLoadingItemsMonth}
                    />
                    <CostPerDay
                        showDetailItem={showDetailItem}
                        itemInValidation={itemInValidation}
                        onUpdateItemInValidation={onUpdateItemInValidation}
                        onUpdatePanelCostSpreadsheet={setUpdatePanelCostSpreadsheet}
                        onUpdateRowIndexSelected={setRowIndexSelected}
                        onUpdateCloseCostSpreadsheet={setCloseCostSpreadsheet}
                        handleClose={handleClose}
                        closeCostSpreadsheet={closeCostSpreadsheet}
                    />
                </Panel>
            </LayoutDefault >
        </>
    )
};

export default HourlyCostSpreadsheet;
